/* unplugin-vue-components disabled */import { render } from "./Empty.vue?vue&type=template&id=15bf65b7&scoped=true"
import script from "./Empty.vue?vue&type=script&lang=js"
export * from "./Empty.vue?vue&type=script&lang=js"

import "./Empty.vue?vue&type=style&index=0&id=15bf65b7&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户内蒙古医科-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15bf65b7"]])

export default __exports__